import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 9 9",
  fill: "none",
  stroke: "white",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.5 6.75C6.57107 6.75 8.25 4.5 8.25 4.5C8.25 4.5 6.57107 2.25 4.5 2.25C2.42893 2.25 0.75 4.5 0.75 4.5C0.75 4.5 2.42893 6.75 4.5 6.75Z",
      "stroke-width": "0.75",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.5 5.4375C5.01776 5.4375 5.4375 5.01776 5.4375 4.5C5.4375 3.98224 5.01776 3.5625 4.5 3.5625C3.98224 3.5625 3.5625 3.98224 3.5625 4.5C3.5625 5.01776 3.98224 5.4375 4.5 5.4375Z",
      "stroke-width": "0.75",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }